module.exports = "<ng-content *ngIf=\"sortField === getCurrentSortField() && isAscending() === false\"></ng-content>\n";